<template>
    <div class="personages-delete">
        <button class="button button--blank" @click.prevent="showConfirm = true">
            <IconBin fill="red" />
        </button>
        <ConfirmModal
            v-if="showConfirm"
            :title="$t('personages.delete.title')"
            :ok-label="$t('misc.delete')"
            @confirmed="deletePersonage"
            @canceled="showConfirm = false"
        >
            <template #content>
                <Spinner v-if="loading" />
                <TransitionExpand v-if="error">
                    <ErrorList :error="error" />
                </TransitionExpand>
            </template>
        </ConfirmModal>
    </div>
</template>

<script>
import { IconBin } from '@speechki-frontend/shared/ui/icons';
import { ConfirmModal } from '@speechki-frontend/shared/ui/modals';
import { ErrorList } from '@speechki-frontend/shared/ui/forms';
import TransitionExpand from '@speechki-frontend/shared/ui/TransitionExpand';
import Spinner from '@speechki-frontend/shared/ui/Spinner';

import { deletePersonage } from '../../api/personages';

export default {
    name: 'PersonagesDelete',
    components: {
        IconBin,
        ConfirmModal,
        TransitionExpand,
        ErrorList,
        Spinner
    },
    props: {
        personageId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            showConfirm: false,
            loading: false,
            error: undefined
        };
    },
    methods: {
        async deletePersonage() {
            try {
                this.loading = true;
                this.error = undefined;

                await deletePersonage(this.personageId);
                this.$emit('deleted', { id: this.personageId });
                this.showConfirm = false;
            } catch (e) {
                this.error = e;
                console.log(e);
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>
